import React from 'react';
import styled, { css } from 'styled-components'

const MenuItem = ({ icon: Icon, status, click }) => {
  return (
    <Container status={status}>
      <Icon
        size={32}
        color={status === 'active' ? '#5ABDE7' : '#FFF'}
        onClick={click}
      />
      {/* <Status status={status} /> */}
    </Container>
  )
}

// ESTILOS
const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 58px;

  cursor: pointer;

  margin-top: 2px;

  ${props => props.status === 'active' && css`
    background: rgba(0, 0, 0, 0.3);
  `}
`
export { MenuItem }